"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomTraceId = void 0;
/**
 * Генерирует TraceId для логирования
 *
 * zipkin использует long (64 бита) в hex представлении
 */
function getRandomTraceId() {
    var digits = '0123456789abcdef';
    var n = '';
    for (var i = 0; i < 16; i += 1) {
        var rand = Math.floor(Math.random() * 16);
        n += digits[rand];
    }
    return n;
}
exports.getRandomTraceId = getRandomTraceId;

//# sourceMappingURL=get-random-trace-id.js.map
